/**
 * Utility function to handle both string and boolean confirmation values
 * for backward compatibility with existing data
 */
export const isConfirmed = (value: any): boolean => {
  return value === true || value === "TRUE";
};

export const isNotConfirmed = (value: any): boolean => {
  return value === false || value === "FALSE" || !value;
};